import {
  type Key,
  type PropsWithChildren,
  createContext,
  useMemo,
} from "react";

import type { AccordionValue } from ".";

export const AccordionContext = createContext<AccordionValue<any> | null>(null);

export function AccordionProvider<ItemId extends Key>({
  children,
  openedItems,
}: PropsWithChildren<AccordionValue<ItemId>>) {
  const value = useMemo<AccordionValue<ItemId>>(
    () => ({
      openedItems,
    }),
    [openedItems]
  );

  return (
    <AccordionContext.Provider value={value}>
      {children}
    </AccordionContext.Provider>
  );
}
